// Configuration file for environment-specific settings
interface Config {
  apiBaseUrl: string;
  socketUrl: string;
  environment: 'development' | 'production';
  features: {
    devTools: boolean;
    debugMode: boolean;
  };
}

const getConfig = (): Config => {
  const environment = (process.env.REACT_APP_ENVIRONMENT as 'development' | 'production') || 'development';
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
  const socketUrl = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

  return {
    apiBaseUrl,
    socketUrl,
    environment,
    features: {
      devTools: environment === 'development',
      debugMode: environment === 'development',
    },
  };
};

export default getConfig();
